import config from '../config.js';
import { authFetch } from '../utils/apiClient.js';

// Citizen-readable document categories, sourced from the DOCUMENT_CATEGORISE
// workflow's own meta_data.document_types.
async function getDocumentTypes(clientId) {
  const res = await authFetch(`${config.backendUrl}/v2/cases/${clientId}/categories`);
  if (!res.ok) throw new Error(`Failed to load categories (${res.status})`);
  const data = await res.json();
  return data.document_types || [];
}

export const categoriesApi = { getDocumentTypes };
